import { EntityState } from '@ngrx/entity';
import { UserProfileEntity } from '../entities';

export interface UserProfileState extends EntityState<UserProfileEntity> {
    currentUserProfileId: number;
    selectedId: number;
    isLoading: boolean;
    isLoaded: boolean;
    isLoadingPublic: boolean;
    isLoadedPublic: boolean;
    isUpdating: boolean;
}
